const CookiePolicy = () => {
  return (
    <main className="min-h-screen py-20 bg-dark-black">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Cookie Policy
          </h1>
          <p className="text-gray-400 mb-8">
            Last updated: 02.12.2025
          </p>
          
          <div className="prose prose-invert max-w-none space-y-6 text-gray-300 leading-relaxed">
            <p className="text-xl text-gray-200">
              This Cookie Policy explains how Empire Wager uses cookies and similar tracking technologies on our website empire-wagers.com. By using our website, you consent to the use of cookies in accordance with this policy.
            </p>

            <h2 className="text-3xl font-bold text-white mt-12 mb-6">What Are Cookies?</h2>
            <p>
              Cookies are small text files that are placed on your device when you visit a website. They are widely used to make websites work more efficiently and to provide information to website owners. Cookies allow websites to recognize your device and remember information about your visit, such as your preferences and actions.
            </p>
            <p>
              Cookies can be "persistent" or "session" cookies. Persistent cookies remain on your device after you close your browser and are used to remember your preferences for future visits. Session cookies are temporary and are deleted when you close your browser.
            </p>

            <h2 className="text-3xl font-bold text-white mt-12 mb-6">How We Use Cookies</h2>
            <p>
              We use cookies for several purposes, including to enable certain functions of the website, to provide analytics, to store your preferences, and to personalize content. We use both first-party cookies (set by our website) and third-party cookies (set by other websites whose services we use).
            </p>
            <p>
              Cookies help us understand how visitors interact with our website by collecting and reporting information anonymously. This information helps us improve our website and provide a better user experience.
            </p>

            <h2 className="text-3xl font-bold text-white mt-12 mb-6">Types of Cookies We Use</h2>
            
            <h3 className="text-2xl font-bold text-white mt-8 mb-4">Essential Cookies</h3>
            <p>
              These cookies are necessary for the website to function properly. They enable core functionality such as security, network management, and accessibility. You cannot opt out of these cookies as they are essential for the website to work.
            </p>
            <p>
              Essential cookies include those that remember your cookie preferences, maintain your session, and ensure security features work correctly. Without these cookies, services you have requested cannot be provided.
            </p>

            <h3 className="text-2xl font-bold text-white mt-8 mb-4">Analytics Cookies</h3>
            <p>
              These cookies help us understand how visitors use our website by collecting and reporting information anonymously. We use analytics cookies to track page views, time spent on pages, and navigation patterns. This information helps us improve our website's performance and user experience.
            </p>
            <p>
              Analytics cookies may be set by third-party services such as Google Analytics. These services use cookies to collect information about your use of our website and compile reports on website activity. The information generated by these cookies is typically transmitted to and stored by the service provider.
            </p>

            <h3 className="text-2xl font-bold text-white mt-8 mb-4">Functional Cookies</h3>
            <p>
              These cookies enable the website to provide enhanced functionality and personalization. They may be set by us or by third-party providers whose services we have added to our pages.
            </p>
            <p>
              Functional cookies remember your preferences, such as language settings, and allow us to provide features you have requested. Without these cookies, some services may not function properly.
            </p>

            <h3 className="text-2xl font-bold text-white mt-8 mb-4">Marketing Cookies</h3>
            <p>
              These cookies are used to track visitors across websites to display relevant advertisements. They may be set by advertising networks with our permission. These cookies remember that you have visited our website and may combine this information with other information they have collected.
            </p>
            <p>
              Marketing cookies help us measure the effectiveness of our advertising campaigns and ensure that advertisements you see are relevant to you. You can opt out of marketing cookies through your browser settings or by using opt-out tools provided by advertising networks.
            </p>

            <h2 className="text-3xl font-bold text-white mt-12 mb-6">Third-Party Cookies</h2>
            <p>
              In addition to our own cookies, we may also use various third-party cookies to report usage statistics of the website, deliver advertisements, and so on. These third-party cookies are set by domains other than ours and are subject to the privacy policies of those third parties.
            </p>
            <p>
              We use third-party services such as Google Analytics to analyze website usage. These services may set cookies on your device to collect information about your use of our website. We do not control these third-party cookies, and you should review the privacy policies of these third parties to understand how they use cookies.
            </p>
            <p>
              Some third-party cookies are used for advertising purposes. These cookies may track your browsing habits across different websites to build a profile of your interests and show you relevant advertisements. You can opt out of these cookies through your browser settings or by using opt-out tools provided by advertising networks.
            </p>

            <h2 className="text-3xl font-bold text-white mt-12 mb-6">Managing Cookies</h2>
            <p>
              You have the right to accept or reject cookies. Most web browsers automatically accept cookies, but you can usually modify your browser settings to decline cookies if you prefer. However, this may prevent you from taking full advantage of the website.
            </p>
            <p>
              You can control cookies through your browser settings. Most browsers allow you to:
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>See what cookies you have and delete them individually</li>
              <li>Block third-party cookies</li>
              <li>Block cookies from particular sites</li>
              <li>Block all cookies from being set</li>
              <li>Delete all cookies when you close your browser</li>
            </ul>
            <p>
              Please note that if you choose to block or delete cookies, some features of our website may not function properly. Essential cookies cannot be disabled as they are necessary for the website to function.
            </p>

            <h2 className="text-3xl font-bold text-white mt-12 mb-6">Browser-Specific Instructions</h2>
            <p>
              To manage cookies in your browser, follow the instructions for your specific browser:
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li><strong>Chrome:</strong> Settings → Privacy and security → Cookies and other site data</li>
              <li><strong>Firefox:</strong> Options → Privacy & Security → Cookies and Site Data</li>
              <li><strong>Safari:</strong> Preferences → Privacy → Cookies and website data</li>
              <li><strong>Edge:</strong> Settings → Privacy, search, and services → Cookies and site permissions</li>
            </ul>
            <p>
              For other browsers, please consult your browser's help documentation or visit the browser manufacturer's website for instructions on managing cookies.
            </p>

            <h2 className="text-3xl font-bold text-white mt-12 mb-6">Do Not Track Signals</h2>
            <p>
              Some browsers include a "Do Not Track" (DNT) feature that signals to websites you visit that you do not want to have your online activity tracked. Currently, there is no standard for how DNT signals should be interpreted, and our website does not respond to DNT signals at this time.
            </p>
            <p>
              We continue to monitor developments around DNT browser technology and the implementation of a standard. If a standard is adopted that we must follow in the future, we will update this Cookie Policy accordingly.
            </p>

            <h2 className="text-3xl font-bold text-white mt-12 mb-6">Cookie Consent</h2>
            <p>
              When you first visit our website, you may see a cookie consent banner that asks you to accept or reject non-essential cookies. You can change your cookie preferences at any time by accessing the cookie settings on our website or through your browser settings.
            </p>
            <p>
              Your consent choices are stored in a cookie, so we can remember your preferences for future visits. If you delete your cookies, you will need to set your preferences again.
            </p>

            <h2 className="text-3xl font-bold text-white mt-12 mb-6">Updates to This Cookie Policy</h2>
            <p>
              We may update this Cookie Policy from time to time to reflect changes in our practices or for other operational, legal, or regulatory reasons. We will notify you of any material changes by posting the new Cookie Policy on this page and updating the "Last updated" date.
            </p>
            <p>
              We encourage you to review this Cookie Policy periodically to stay informed about how we use cookies. Your continued use of our website after any changes to this Cookie Policy constitutes your acceptance of the updated policy.
            </p>

            <h2 className="text-3xl font-bold text-white mt-12 mb-6">Contact Us</h2>
            <p>
              If you have any questions about our use of cookies or this Cookie Policy, please contact us:
            </p>
            <p>
              <strong>Email:</strong> info@empire-wagers.com<br />
              <strong>Phone:</strong> +44 5511 778 569<br />
              <strong>Address:</strong> London, United Kingdom
            </p>
          </div>
        </div>
      </div>
    </main>
  );
};

export default CookiePolicy;

